import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetNotificationCountQueryVariables = Types.Exact<{
  filters: Types.UserFilters;
}>;


export type GetNotificationCountQuery = { user?: { id: string, unresolvedNotificationsCount: number, unreadNotificationsCount: number } | null };


export const GetNotificationCountDocument = /*#__PURE__*/ gql`
    query getNotificationCount($filters: UserFilters!) {
  user(filters: $filters) {
    id
    unresolvedNotificationsCount
    unreadNotificationsCount
  }
}
    `;

export function useGetNotificationCountQuery(options: Omit<Urql.UseQueryArgs<GetNotificationCountQueryVariables>, 'query'>) {
  return Urql.useQuery<GetNotificationCountQuery, GetNotificationCountQueryVariables>({ query: GetNotificationCountDocument, ...options });
};